import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import { Task } from "./task";
import styles from "./styles.scss";

function Column(props: Props) {
  return (
    <div className={styles.columnDropBox}>
      <div className={styles.column}>
        <div className={styles.heading}>
          <div className={styles.iconBox}>
            <Skeleton className={styles.icon} />
          </div>
          <Skeleton className={styles.title} />
        </div>
        <div className={styles.tasks}>
          <Task />
          <Task />
          <Task />
          <Task />
          <Task />
          <Task />
          <Task />
          <Task />
          <Task />
        </div>
      </div>
    </div>
  );
}

export { Column };
